"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var components_1 = require("components");
var componentStyle = {
    base: {
        height: 50,
        display: 'flex',
        alignItems: 'center',
        padding: '0 3px 0 18px',
    },
    header: {
        flex: 1,
        margin: 0,
    },
};
exports.ExampleHeader = function (_a) {
    var title = _a.title, onClickShowCode = _a.onClickShowCode;
    return (React.createElement("div", { style: componentStyle.base },
        React.createElement("h3", { style: componentStyle.header }, title),
        React.createElement(components_1.Button, { flat: true, onClick: onClickShowCode }, "Toggle Code")));
};
exports.ExampleHeader.displayName = 'ExampleHeader';
exports.ExampleHeader.defaultProps = {
    title: 'Example',
    onClickShowCode: function () { return null; },
};



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Example/ExampleHeader.tsx
// module id = 616
// module chunks = 0